import React from 'react';
import Dotdotdot from 'react-dotdotdot';
import AnimateNumber from '@alife/bc-animate-number';
import Balloon from '@alifd/next/lib/balloon/index';
import Icon from '@alifd/next/lib/icon/index';
// import ShippingTag from '../promotion-tag/shipping';
import * as I18n from 'src/utils/i18n';
// import { getActivityType } from '../promotion-tag/utils';

const FORCAST_COST = 'forecast'; // 预估运费

export default function Logistics(props) {
  const {
    isEmpty,
    method,
    tradeTerm,
    discount,
    handleClick,
    fullCountry,
    originalCost,
    cost,
    isFreeShipping,
    logisticsCostCalculationType,
    showPromotion,
    discountLimit,
    activityFlagUrl,
    i18n = {},
    shippingActivityId,
  } = props;
  // const tradeTermMap = {
  //   DDP: {
  //     title: i18n['rightAction.ddp'],
  //     tip: i18n['rightAction.ddpTip'],
  //   },
  //   DDU: {
  //     title: i18n['rightAction.ddu'],
  //     tip: i18n['rightAction.dduTip'],
  //   },
  // };
  let shipText = `${fullCountry}`;
  if (!isEmpty) {
    shipText += ` ${i18n['rightAction.by']} ${method}`;
  }
  const cls = showPromotion
    ? 'sub-item-right sub-item-right-algin-top'
    : 'sub-item-right';

  // const activityType = getActivityType(shippingActivityId);

  return (
    <li className="sub-item float-action-logistics">
      <span
        className="sub-item-name"
        title={`${i18n['rightAction.shipto']} ${shipText}`}
        // 触发点
        id="wholesale-tansport-selector"
        onClick={handleClick}
      >
        <Dotdotdot clamp={2}>
          {i18n['rightAction.shipto']}{' '}
          <span className="logistics-method">{shipText}</span>
        </Dotdotdot>
      </span>
      {isEmpty && (
        <span className="sub-item-right logistics-to-be-negotiated">
          {i18n['rightAction.negotiated']}
        </span>
      )}
      {!isEmpty && (
        <span className={cls}>
          {isFreeShipping && i18n['rightAction.freeshipping']}
          {!isFreeShipping && logisticsCostCalculationType === FORCAST_COST && (
            <span className="logistics-est">{i18n['rightAction.est']}</span>
          )}
          {!isFreeShipping && <AnimateNumber value={cost} />}
          {/* 展示ddp、ddu标志，展示大促物流标的时候，隐藏ddu和ddp */}
          {/* {!isFreeShipping &&
            !showPromotion &&
            tradeTerm &&
            tradeTerm === 'DDP' && (
              <span className="ddp-item">
                {tradeTermMap[tradeTerm].title}
                <Balloon
                  trigger={
                    <Icon
                      type="prompt"
                      size="small"
                      style={{ marginLeft: '4px', verticalAlign: 'bottom' }}
                    />
                  }
                  closable={false}
                  cache
                  align="bl"
                  popupContainer={() =>
                    document.querySelector('.float-action-inner')
                  }
                  style={{ width: '240px' }}
                >
                  <div>{tradeTermMap[tradeTerm].tip}</div>
                </Balloon>
              </span>
            )} */}
          {/* 运费后展示i气泡，提醒运费为预估运费 */}
          {!isEmpty && logisticsCostCalculationType === FORCAST_COST && (
            <Balloon
              trigger={
                <Icon
                  type="prompt"
                  size="small"
                  style={{ marginLeft: '4px' }}
                />
              }
              closable={false}
              cache
              align="bl"
              popupContainer={() =>
                document.querySelector('.float-action-inner')
              }
              style={{ width: '240px' }}
            >
              <div>
                {i18n['rightAction.estTip1']}
                <span className="logistics-trigger" onClick={handleClick}>
                  {i18n['rightAction.estTip2']}
                </span>
              </div>
            </Balloon>
          )}
          {/* 大促物流标 - 原价 */}
          {showPromotion && originalCost && (
            <div className="logistics-origin-cost">
              <del>{originalCost}</del>
            </div>
          )}

          {tradeTerm === 'DDP' ? (
            <span className="actions-logis__ddp-text">
              (
              {I18n.get('undue_tpl_helpers.text_market_ddp_tips') ||
                'Delivery Duty Paid(DDP)'}
              )
            </span>
          ) : null}

          {/* 物流活动标 */}
          {/* {activityType ? <ShippingTag type={activityType} /> : null} */}

          {/* 大促物流标 - 折扣 */}
          {showPromotion && activityFlagUrl && (
            <div className="logistics-discount">
              <img src={activityFlagUrl} />
            </div>
          )}
          {/* 大促物流标 - 限价条件 */}
          {/* {showPromotion && discountLimit && (
            <div className="logistics-limit"> {discountLimit}</div>
          )} */}
        </span>
      )}
    </li>
  );
}
